import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Table, Dropdown, Icon, Select, Tab } from "semantic-ui-react";
//import { Line } from "@ant-design/charts";
import { Pie, Column, DualAxes } from "@ant-design/plots";
import { Link, useLocation } from "react-router-dom";
import {
  Permission,
  // Fuelsform,
  // Form,
  // Productionform,
  // Energyform,
} from "../../../../api";
import { useAuth } from "../../../../hooks";
import "./GEIDashBoard.scss";
import { useLanguage } from "../../../../contexts/LanguageContext";
import FuelSummary from "./GEISummary";
import TableGraf from "./TableGraf";
import {
  fuelsKPIsCodes,
  fuelsFormulasIndicators,
  determineFuelsUnits,
  fuelsCodes,
  // convertUnitsFinal,
  fuelsTotalMWh,
} from "../../../../utils/dataAndFormulas/fuelsForms";

import {
  convertUnits,
  formatValue,
} from "../../../../utils/dataAndFormulas/convert";
import { BasicModal, LoadingSpinner } from "../../../Shared";
import {
  convertEnergy2,
  convertUnitsFinal,
} from "../../../../utils/dataAndFormulas/convertEnergy";
import {
  calculateEmissionsByType,
  geiCodes,
} from "../../../../utils/dataAndFormulas/GEIForms";

const permissionController = new Permission();
// const fuelsController = new Fuelsform();
// const energyController = new Energyform();
// const formController = new Form();
// const productionController = new Productionform();

export function GEIDashBoard(props) {
  const { site } = props;
  const {
    user: { role },
    accessToken,
  } = useAuth();

  const { language, translations } = useLanguage();

  const t = (key) => translations[key] || key; // Función para obtener la traducción

  const [permissionActive, setPermissionsActive] = useState([]);
  const [baseline, setbaseline] = useState("");
  const [valueBaseline, setValueBaseline] = useState({});
  const [indicatorsLineBaseEnergy, setIndicatorsLineBaseEnergy] = useState([]);
  const [indicatorsLineBaseGEI, setIndicatorsLineBaseGEI] = useState([]);
  // const isAdmin = (role? role.name : "") === "admin";

  const [data, setData] = useState([]);
  const [totales, setTotales] = useState({});
  const [conceptos, setConceptos] = useState([]);
  const [totalesScopes, setTotalesScopes] = useState({});

  const [energyData, setEnergyData] = useState([]);
  const [totalesEnergy, setTotalesEnergy] = useState({});
  const [conceptosEnergy, Energy] = useState([]);

  const [activeFieldsEnergy, setActiveFieldsEnergy] = useState([]);
  const [activeFieldsFuels, setActiveFieldsFuels] = useState([]);

  const [loadingCount, setLoadingCount] = useState(0);
  const isLoading = loadingCount > 0;

  const [lastYears, setLastYears] = useState({}); // resultados calculados
  const [totalesByFilters, setTotalesByFilters] = useState({}); // resultados calculados

  const startLoading = () => setLoadingCount((prev) => prev + 1);
  const stopLoading = () => setLoadingCount((prev) => Math.max(prev - 1, 0));
  //declaración estado de filtros
  const [filters, setFilters] = useState({
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
  });

  useEffect(() => {
    (async () => {
      startLoading();
      try {
        setPermissionsActive([]);
        if (role) {
          const response = await permissionController.getPermissionsByRole(
            accessToken,
            role._id,
            true,
          );
          setPermissionsActive(response);
        }
      } catch (error) {
        console.error(error);
        //vehiclesKPIsCodes.error(error);
        setPermissionsActive([]);
      } finally {
        stopLoading();
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (!site) return;

      startLoading();

      try {
        setData([]);
        setEnergyData([]);

        // ✅ Últimos 5 años fijos
        const currentYear = new Date().getFullYear();
        const last5Years = Array.from({ length: 5 }, (_, i) =>
          String(currentYear - i),
        );

        // 🚀 Paralelizar llamadas base + configs
        const [
          fuelsPrueba,
          energyPrueba,
          geiFormData,
          energyConfig,
          fuelsConfig,
        ] = await Promise.all([
          fuelsController.getFuelsFormsByLineBaseYears(accessToken, site),
          energyController.getEnergyFormsByLineBaseYears(accessToken, site),
          formController.getFormsBySite(accessToken, site, "gei"),
          formController.getFormsBySite(accessToken, site, "energy"),
          formController.getFormsBySite(accessToken, site, "fuels"),
        ]);

        // Indicadores línea base
        setIndicatorsLineBaseEnergy(energyPrueba.energyForms.indicators || []);

        if (geiFormData?.[0]) {
          setIndicatorsLineBaseGEI(geiFormData[0].indicators || []);
        }

        // Campos activos Energy
        if (energyConfig?.[0]?.fields) {
          setActiveFieldsEnergy(
            energyConfig[0].fields
              .filter((field) => field.active !== false)
              .map((field) => field.name),
          );
        }

        // Campos activos Fuels
        if (fuelsConfig?.[0]?.fields) {
          setActiveFieldsFuels(
            fuelsConfig[0].fields
              .filter((field) => field.active !== false)
              .map((field) => field.name),
          );
        }

        // 🚀 Datos SOLO últimos 5 años
        const [fuelsResponse, energyResponse] = await Promise.all([
          fuelsController.getFuelsFormsByLastYears(
            accessToken,
            site,
            last5Years,
          ),
          energyController.getEnergyFormsByLastYears(
            accessToken,
            site,
            last5Years,
          ),
        ]);

        setData(fuelsResponse.fuelsForms);
        setEnergyData(energyResponse.energyForms);
      } catch (error) {
        console.error("Error loading GEI data:", error);
        setData([]);
        setEnergyData([]);
      } finally {
        stopLoading();
      }
    })();
  }, [site]);

  useEffect(() => {
    (async () => {
      startLoading();
      setbaseline("");
      try {
        if (site) {
          const response = await formController.getLastBaselineByFormBySite(
            accessToken,
            site,
            "production",
          );

          if (response.code === 200) {
            setbaseline(response.baseline);

            //Para saber el total de los años de baseline sin necesidad de andar consultando varias veces
            const resultado = await Promise.all(
              Object.entries(response.baseline)
                .filter(([anio, valor]) => valor !== null) // Filtra por los valores no nulos
                .map(async ([anio, valor]) => {
                  let a = await getValueBaseLine(anio, valor); // Llamada a la función asincrónica
                  return { [anio]: a }; // Devuelve el año y el valor como un objeto
                }),
            );

            // Combina todos los objetos en un único objeto final
            const resultadoFinal = resultado.reduce((acc, obj) => {
              return { ...acc, ...obj }; // Combina los objetos
            }, {});

            setValueBaseline(resultadoFinal);
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        stopLoading();
      }
    })();
  }, [site]);

  // 🚀 Memoizar campos de códigos (no cambian durante la sesión)
  const determineFieldsCode = useMemo(() => {
    const fields = new Set();
    Object.keys(geiCodes).forEach((key) => {
      fields.add(key);
    });
    return Array.from(fields);
  }, []);

  useEffect(() => {
    (async () => {
      if (!data || !energyData || !valueBaseline) return;

      startLoading();
      try {
        // 🚀 Transformaciones síncronas (ya no son async)
        const previous_totals = transformData1(data);
        const previous_totals_energy = transformData1(energyData);

        const totalFinal = calcularEmisionesTotalesPorAnio(previous_totals);
        const totalFinalEnergy = calcularEmisionesTotalesPorAnio(
          previous_totals_energy,
        );

        setTotales(totalFinal.detalles);
        setTotalesEnergy(totalFinalEnergy.detalles);

        // Combinar resultados por alcance
        const combinedResults = {};
        const years = new Set([
          ...Object.keys(totalFinalEnergy.resultadosPorAlcance || {}),
          ...Object.keys(totalFinal.resultadosPorAlcance || {}),
        ]);

        years.forEach((year) => {
          const r1 = totalFinalEnergy.resultadosPorAlcance?.[year] || {};
          const r2 = totalFinal.resultadosPorAlcance?.[year] || {};

          combinedResults[year] = {
            scope1: (r1.scope1 || 0) + (r2.scope1 || 0),
            scope2: (r1.scope2 || 0) + (r2.scope2 || 0),
            scope3: (r1.scope3 || 0) + (r2.scope3 || 0),
          };
        });

        setTotalesScopes(combinedResults);

        // 🔍 Filtrar solo campos activos
        const allActiveFields = [...activeFieldsEnergy, ...activeFieldsFuels];
        const filteredConcepts = determineFieldsCode.filter((concept) =>
          allActiveFields.includes(concept),
        );

        console.log("🔍 Conceptos filtrados (solo activos):", filteredConcepts);
        setConceptos(filteredConcepts);
      } catch (error) {
        console.error("Error processing data:", error);
      } finally {
        stopLoading();
      }
    })();
  }, [
    data,
    energyData,
    valueBaseline,
    determineFieldsCode,
    activeFieldsEnergy,
    activeFieldsFuels,
  ]);

  //Calcula el valor de linea base por año hay que cambiar si es por vfs o vps
  const getValueBaseLine = async (year, type) => {
    try {
      if (type === "VPS") {
        const response1 =
          await productionController.getTotalBaselineByYearAndSite(
            accessToken,
            site,
            year,
            "standardized_production",
          );
        //setValueBaseline(response1.total)

        return response1.total;
      } else {
        const response1 =
          await productionController.getTotalBaselineByYearAndSite(
            accessToken,
            site,
            year,
            "standardized_billing",
          );

        return response1.total;
      }
    } catch (error) {
      console.error(error);
      return 1;
    }
  };
  // 🚀 Optimizar transformData1 - remover async innecesario y usar map más eficiente
  const transformData1 = useCallback(
    (data) => {
      const totalsPerYear = {};
      const fields = determineFieldsCode;

      // Validación inicial
      if (!data || !Array.isArray(data.data) || data.data.length === 0) {
        return {};
      }

      // Procesamos directamente los datos (no necesitamos async aquí)
      data.data.forEach((item) => {
        const year = String(item.year);

        fields.forEach((concept) => {
          if (item[concept]) {
            // Inicializar estructura si no existe
            if (!totalsPerYear[concept]) totalsPerYear[concept] = {};

            if (!totalsPerYear[concept][year]) {
              totalsPerYear[concept][year] = {
                total: 0,
                unit: item[concept].unit || "",
              };
            } else if (
              !totalsPerYear[concept][year].unit &&
              item[concept].unit
            ) {
              // Si la unidad anterior está vacía y la nueva tiene valor, la actualizamos
              totalsPerYear[concept][year].unit = item[concept].unit;
            }

            // Sumar el valor, convirtiendo si hay diferencia de unidades
            totalsPerYear[concept][year].total += item[concept].value
              ? convertUnitsFinal(
                  item[concept].value,
                  item[concept].unit,
                  totalsPerYear[concept][year].unit,
                  concept,
                )
              : 0;
          }
        });
      });

      return totalsPerYear;
    },
    [determineFieldsCode],
  );

  // Función para obtener los valores de un año y mes específicos (period en texto)
  const getDataByYearAndMonth = async (data, year, month) => {
    const results = {};
    const fields = determineFieldsCode();
    const unitsCache = {};

    if (!data || !data || Object.keys(data).length === 0) {
      return {};
    }

    // Diccionario de meses
    const monthMap = {
      January: "01",
      February: "02",
      March: "03",
      April: "04",
      May: "05",
      June: "06",
      July: "07",
      August: "08",
      September: "09",
      October: "10",
      November: "11",
      December: "12",
    };

    const yearStr = String(year);
    const monthStr =
      typeof month === "string"
        ? monthMap[month] || ""
        : String(month).padStart(2, "0");

    if (!monthStr) {
      console.warn("Mes inválido o no reconocido:", month);
      return {};
    }

    const yearData = data[yearStr];
    if (!Array.isArray(yearData)) {
      console.warn("No hay datos para el año:", yearStr);
      return {};
    }

    const filteredData = yearData.filter(
      (item) => monthMap[item.period] === monthStr,
    );

    if (filteredData.length === 0) {
      console.warn(`No hay datos para ${month} ${yearStr}`);
      return {};
    }

    // Procesar resultados por campo
    filteredData.forEach((item) => {
      const units = unitsCache[yearStr];

      fields.forEach((concept) => {
        if (item[concept]) {
          if (!results[concept]) {
            results[concept] = {
              total: 0,
              unit: units?.fields[concept] || item[concept]?.unit || "",
            };
          }

          results[concept].total += item[concept].value
            ? convertUnitsFinal(
                item[concept].value,
                item[concept].unit,
                results[concept].unit,
                concept,
              )
            : 0;
        }
      });
    });

    // ==========================
    // 🔹 Calcular energía total (sin incluir costos)
    // ==========================

    // Lista de conceptos energéticos (sin costos)
    const energyConcepts = Object.keys(geiCodes).filter(
      (key) => !key.includes("cost"),
    );

    let totalEnergyMonth = 0;
    let energyUnit = "";

    energyConcepts.forEach((concept) => {
      if (results[concept] && typeof results[concept].total === "number") {
        totalEnergyMonth += results[concept].total;
        energyUnit = results[concept].unit || energyUnit;
      }
    });

    results.total_energy_month = {
      total: totalEnergyMonth,
      unit: energyUnit || "MWh",
    };

    // ==========================
    // 🔹 Calcular renovables
    // ==========================
    // Ejemplo: filtramos solo las claves que sean renovables
    const renewableConcepts = Object.keys(geiCodes).filter((key) =>
      key.includes("renewable"),
    );

    let renewableTotal = 0;
    let renewableUnit = "";

    renewableConcepts.forEach((concept) => {
      if (results[concept] && typeof results[concept].total === "number") {
        renewableTotal += results[concept].total;
        renewableUnit = results[concept].unit || renewableUnit;
      }
    });

    results.renewable_energy_month = {
      total: renewableTotal,
      unit: renewableUnit || "MWh",
    };

    // ==========================
    // 🔹 Calcular electrica
    // ==========================

    // Filtramos solo los conceptos eléctricos
    const electricConcepts = Object.keys(geiCodes).filter((key) =>
      key.includes("electricity"),
    );

    let electricTotal = 0;
    let electricUnit = "";

    electricConcepts.forEach((concept) => {
      if (results[concept] && typeof results[concept].total === "number") {
        electricTotal += results[concept].total;
        electricUnit = results[concept].unit || electricUnit;
      }
    });

    results.electrica = {
      total: electricTotal,
      unit: electricUnit || "MWh",
    };

    return results;
  };

  const getLastThreeYearsData = async (totalesByFilters) => {
    const currentYear = new Date().getFullYear();
    const lastThreeYears = [currentYear - 2, currentYear - 1, currentYear];

    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const resultsByYear = {};

    for (const year of lastThreeYears) {
      resultsByYear[year] = {};

      for (const month of months) {
        const data = await getDataByYearAndMonth(totalesByFilters, year, month);
        resultsByYear[year][month] = data;
      }
    }

    return resultsByYear;
  };

  // 🚀 Memoizar función de cálculo de emisiones
  const calcularEmisionesTotalesPorAnio = useCallback(
    (totales, opciones = {}) => {
      const resultados = {};
      const resultadosPorAlcance = {};
      const detalles = {};

      for (const fuelType in totales) {
        const años = totales[fuelType];
        detalles[fuelType] = {};

        for (const year in años) {
          const { total, unit } = años[year];

          if (!resultados[year]) resultados[year] = 0;
          if (!resultadosPorAlcance[year])
            resultadosPorAlcance[year] = { scope1: 0, scope2: 0, scope3: 0 };
          if (!detalles[fuelType][year])
            detalles[fuelType][year] = {
              emissions: 0,
              scope1: 0,
              scope2: 0,
              scope3: 0,
            };

          const { emisiones, alcance } = calculateEmissionsByType(
            total,
            unit,
            fuelType,
            opciones,
          );

          detalles[fuelType][year].emissions += emisiones;

          if (alcance === 1) {
            detalles[fuelType][year].scope1 += emisiones;
            resultadosPorAlcance[year].scope1 += emisiones;
          } else if (alcance === 2) {
            detalles[fuelType][year].scope2 += emisiones;
            resultadosPorAlcance[year].scope2 += emisiones;
          } else if (alcance === 3) {
            detalles[fuelType][year].scope3 += emisiones;
            resultadosPorAlcance[year].scope3 += emisiones;
          }

          resultados[year] += emisiones;
        }
      }

      return { resultados, resultadosPorAlcance, detalles };
    },
    [],
  );

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (
    !data ||
    !data.years ||
    data.years.length === 0 ||
    !conceptos ||
    conceptos.length === 0
  ) {
    return (
      <div style={{ textAlign: "center", padding: "5em 0", color: "#777" }}>
        <div style={{ fontSize: "2em", marginBottom: "1em", color: "#ccc" }}>
          <Icon name="exclamation triangle" size="huge" color="gray" />
        </div>
        <div
          style={{ fontSize: "1.5em", fontWeight: "bold", marginBottom: "1em" }}
        >
          {t("no_data_available") || "No hay datos disponibles"}
        </div>
      </div>
    );
  } else {
    return (
      <div className="list-fuels-forms">
        {/* Sección de Resumen */}
        <div className="gei-summary-section">
          <FuelSummary
            filters={filters}
            site={site}
            valueBaseline={valueBaseline}
            fuelsController={Fuelsform}
            totales={totalesScopes}
            selectorSlot={<YearMonthSelector onChange={setFilters} />}
          />
        </div>

        {/* Sección de Gráficos */}
        <div className="gei-tablegraf-section">
          <TableGraf
            filters={filters}
            totales={{ ...totales, ...totalesEnergy }}
            totalesScopes={totalesScopes}
            valueBaseline={valueBaseline}
            t={t}
          />
        </div>

        {/* Sección de Tabla de Datos */}
        <div className="gei-table-section">
          <TableYears
            filters={filters}
            data={data}
            accessToken={accessToken}
            t={t}
            conceptos={conceptos}
            totales={{ ...totales, ...totalesEnergy }}
            language={language}
            indicatorsLineBaseGEI={indicatorsLineBaseGEI}
            valueBaseline={valueBaseline}
            totalesEnergy={totalesEnergy}
          />
        </div>
      </div>
    );
  }
}

// 🚀 Memoizar componente TableYears para evitar re-renders innecesarios
const TableYears = React.memo(function TableYears(props) {
  const {
    data,
    conceptos,
    totales,
    t,
    language,
    indicatorsLineBaseGEI,
    filters,
  } = props;

  const { year, month } = filters || {};
  const [years, setYears] = useState([]);
  //const [listConceptos, setListConceptos] = useState([]);
  const [months, setMoths] = useState([]);
  const [listConceptos, setListConceptos] = useState([]);

  //const [uniqueFields, setUniqueFields] = useState([]);
  const [selectedUnits, setSelectedUnits] = useState([]);

  const handleUnitChange = (rowIndex, newValue) => {
    setSelectedUnits({ ...selectedUnits, [rowIndex]: newValue.value });
  };
  useEffect(() => {
    // console.log("📊 TableGraf filtrando con:", { year, month });
  }, [year, month]);

  useEffect(() => {
    (async () => {
      try {
        setYears(data.years ? data.years.sort((a, b) => b - a) : []);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [data]);

  useEffect(() => {
    (async () => {
      try {
        // Obtener todos los campos únicos
        let valor = {};
        conceptos.map(
          (field) => (valor[field] = determineFuelsUnits(field)[0].value),
        );
        setSelectedUnits(valor);
      } catch (error) {
        //console.error(error);
        setSelectedUnits([]);
      }
    })();
  }, [conceptos]);

  useEffect(
    () => {
      (async () => {
        try {
          setListConceptos(conceptos);
        } catch (error) {
          console.error(error);
        }
      })();
    }, // [conceptos, setListConceptos]); //[conceptos]
    [conceptos],
  );

  // Función para obtener el icono de aumento o disminución
  const getComparativeIcon = (currentYear, previousYear) => {
    if (previousYear !== null) {
      if (currentYear > previousYear) {
        return <Icon disabled name="angle up" color="green" />; // Aumento
      } else if (currentYear < previousYear) {
        return <Icon disabled name="angle down" color="red" />; // Disminución
      } else if (currentYear === previousYear) {
        return <span style={{ color: "blue", fontWeight: "bold" }}>=</span>;
      }
    }
    return null; // Sin cambio
  };

  // Determina los decimales necesarios para un valor individual
  const getNeededDecimals = (value) => {
    if (typeof value !== "number" || isNaN(value) || value === 0) return 2;
    const abs = Math.abs(value);
    if (abs >= 0.005) return 2;
    if (abs >= 0.0005) return 3;
    if (abs >= 0.00005) return 4;
    return -1;
  };

  // Determina la cantidad de decimales consistente para toda una fila
  const getRowDecimalPlaces = (values) => {
    let maxDecimals = 2;
    for (const v of values) {
      if (typeof v !== "number" || isNaN(v) || v === 0) continue;
      const needed = getNeededDecimals(v);
      if (needed === -1) continue;
      if (needed > maxDecimals) maxDecimals = needed;
    }
    return Math.min(maxDecimals, 4);
  };

  // Formatea un valor con la cantidad de decimales determinada para la fila
  const formatWithDecimals = (value, decimals) => {
    if (typeof value !== "number" || isNaN(value)) return "-";
    if (value === 0) return "-";
    if (Math.abs(value) < 0.00005) return (0).toFixed(decimals);
    return value.toFixed(decimals);
  };

  // Renderiza una píldora de comparativa rojo/verde
  const renderPill = (value, prevValue, decimals) => {
    const numValue = value != null ? Number(value) : null;
    const numPrev = prevValue != null ? Number(prevValue) : null;

    if (numValue == null || numValue === 0) {
      return <span className="gei-value-pill pill-empty" />;
    }

    let pillClass;
    if (numPrev == null || numPrev === 0) {
      pillClass = "pill-neutral";
    } else if (numValue > numPrev) {
      pillClass = "pill-up";
    } else if (numValue < numPrev) {
      pillClass = "pill-down";
    } else {
      pillClass = "pill-neutral";
    }

    return (
      <span className={`gei-value-pill ${pillClass}`}>
        {formatWithDecimals(numValue, decimals)}
      </span>
    );
  };

  return (
    <>
      <Table celled structured size="small" className="gei-kpi-table">
        <Table.Header>
          {/* 🔹 Primera fila: encabezado principal */}
          <Table.Row>
            <Table.HeaderCell rowSpan="2" textAlign="center">
              {t("code")}
            </Table.HeaderCell>
            <Table.HeaderCell rowSpan="2" textAlign="center">
              {t("indicators")}
            </Table.HeaderCell>

            {/* 🔹 Cada año ocupa 3 columnas (A1, A2, A3) */}
            {years.map((year, index) => (
              <Table.HeaderCell key={index} colSpan="3" textAlign="center">
                {year}
              </Table.HeaderCell>
            ))}

            {/* 🔹 Línea Base ocupa 3 columnas (A1, A2, A3) */}
            <Table.HeaderCell colSpan="3" textAlign="center">
              {t("LB")}
            </Table.HeaderCell>

            <Table.HeaderCell rowSpan="2" textAlign="center">
              {t("units") || "Unidades"}
            </Table.HeaderCell>
          </Table.Row>

          {/* 🔹 Segunda fila: alcances */}
          <Table.Row>
            {years.map((year, i) => (
              <React.Fragment key={i}>
                <Table.HeaderCell textAlign="center">A1</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">A2</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">A3</Table.HeaderCell>
              </React.Fragment>
            ))}
            {/* 🔹 Alcances para línea base */}
            <Table.HeaderCell textAlign="center">A1</Table.HeaderCell>
            <Table.HeaderCell textAlign="center">A2</Table.HeaderCell>
            <Table.HeaderCell textAlign="center">A3</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {conceptos
            .filter((item) => {
              // 🔹 Filtrar conceptos que tengan al menos un valor diferente de cero
              const hasNonZeroValue = years.some((year) => {
                const yearData = totales[item]?.[year] || {};
                return (
                  (yearData.scope1 || 0) !== 0 ||
                  (yearData.scope2 || 0) !== 0 ||
                  (yearData.scope3 || 0) !== 0
                );
              });

              // 🔹 También verificar línea base
              const alcance1Result = indicatorsLineBaseGEI.find(
                (value) => value.name === "alcance_1_kpis",
              );
              const alcance2Result = indicatorsLineBaseGEI.find(
                (value) => value.name === "alcance_2_kpis",
              );
              const alcance3Result = indicatorsLineBaseGEI.find(
                (value) => value.name === "alcance_3_kpis",
              );

              const baselineYearA1 = alcance1Result?.yearBaseline;
              const baselineYearA2 = alcance2Result?.yearBaseline;
              const baselineYearA3 = alcance3Result?.yearBaseline;

              const baselineDataA1 = totales[item]?.[baselineYearA1] || {};
              const baselineDataA2 = totales[item]?.[baselineYearA2] || {};
              const baselineDataA3 = totales[item]?.[baselineYearA3] || {};

              const hasNonZeroBaseline =
                (baselineDataA1.scope1 || 0) !== 0 ||
                (baselineDataA2.scope2 || 0) !== 0 ||
                (baselineDataA3.scope3 || 0) !== 0;

              return hasNonZeroValue || hasNonZeroBaseline;
            })
            .map((item, index) => {
              // Recopilar todos los valores de la fila para determinar decimales consistentes
              const rowValues = [];
              years.forEach((y) => {
                const yd = totales[item]?.[y] || {};
                if (yd.scope1) rowValues.push(Number(yd.scope1));
                if (yd.scope2) rowValues.push(Number(yd.scope2));
                if (yd.scope3) rowValues.push(Number(yd.scope3));
              });

              // LB values
              const alcance1Result = indicatorsLineBaseGEI.find(
                (value) => value.name === "alcance_1_kpis",
              );
              const alcance2Result = indicatorsLineBaseGEI.find(
                (value) => value.name === "alcance_2_kpis",
              );
              const alcance3Result = indicatorsLineBaseGEI.find(
                (value) => value.name === "alcance_3_kpis",
              );
              const baselineYearA1 = alcance1Result?.yearBaseline;
              const baselineYearA2 = alcance2Result?.yearBaseline;
              const baselineYearA3 = alcance3Result?.yearBaseline;
              const baselineDataA1 = totales[item]?.[baselineYearA1] || {};
              const baselineDataA2 = totales[item]?.[baselineYearA2] || {};
              const baselineDataA3 = totales[item]?.[baselineYearA3] || {};
              if (baselineDataA1.scope1) rowValues.push(Number(baselineDataA1.scope1));
              if (baselineDataA2.scope2) rowValues.push(Number(baselineDataA2.scope2));
              if (baselineDataA3.scope3) rowValues.push(Number(baselineDataA3.scope3));

              const rowDecimals = getRowDecimalPlaces(rowValues);

              return (
              <React.Fragment key={index}>
                <Table.Row>
                  <Table.Cell>{geiCodes[item]}</Table.Cell>
                  <Table.Cell>{t(item)}</Table.Cell>

                  {/* 🔹 Renderiza las tres columnas por año con píldoras de comparativa */}
                  {years.map((year, i) => {
                    const yearData = totales[item]?.[year] || {};
                    const prevYearData = totales[item]?.[years[i + 1]] || {};

                    return (
                      <React.Fragment key={i}>
                        <Table.Cell textAlign="center">
                          {renderPill(yearData.scope1, prevYearData.scope1, rowDecimals)}
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                          {renderPill(yearData.scope2, prevYearData.scope2, rowDecimals)}
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                          {renderPill(yearData.scope3, prevYearData.scope3, rowDecimals)}
                        </Table.Cell>
                      </React.Fragment>
                    );
                  })}

                  {/* 🔹 Línea base - valor fijo sin comparativa */}
                  <>
                    <Table.Cell textAlign="center">
                      {formatWithDecimals(Number(baselineDataA1.scope1), rowDecimals)}
                    </Table.Cell>
                    <Table.Cell textAlign="center">
                      {formatWithDecimals(Number(baselineDataA2.scope2), rowDecimals)}
                    </Table.Cell>
                    <Table.Cell textAlign="center">
                      {formatWithDecimals(Number(baselineDataA3.scope3), rowDecimals)}
                    </Table.Cell>
                  </>

                  {/* 🔹 Unidades */}
                  <Table.Cell>{selectedUnits[item] || ""}</Table.Cell>
                </Table.Row>
              </React.Fragment>
              );
            })}
        </Table.Body>
      </Table>
    </>
  );
});

// 🚀 Memoizar YearMonthSelector
export const YearMonthSelector = React.memo(({ onChange }) => {
  const currentYear = useMemo(() => new Date().getFullYear(), []);

  const years = useMemo(
    () => [
      { key: currentYear, text: currentYear, value: currentYear },
      { key: currentYear - 1, text: currentYear - 1, value: currentYear - 1 },
      { key: currentYear - 2, text: currentYear - 2, value: currentYear - 2 },
      { key: currentYear - 3, text: currentYear - 3, value: currentYear - 3 },
      { key: currentYear - 4, text: currentYear - 4, value: currentYear - 4 },
    ],
    [currentYear],
  );

  const months = useMemo(
    () => [
      { key: 1, text: "Enero", value: 1 },
      { key: 2, text: "Febrero", value: 2 },
      { key: 3, text: "Marzo", value: 3 },
      { key: 4, text: "Abril", value: 4 },
      { key: 5, text: "Mayo", value: 5 },
      { key: 6, text: "Junio", value: 6 },
      { key: 7, text: "Julio", value: 7 },
      { key: 8, text: "Agosto", value: 8 },
      { key: 9, text: "Septiembre", value: 9 },
      { key: 10, text: "Octubre", value: 10 },
      { key: 11, text: "Noviembre", value: 11 },
      { key: 12, text: "Diciembre", value: 12 },
    ],
    [],
  );

  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);

  const handleYearChange = useCallback(
    (e, { value }) => {
      setSelectedYear(value);
      onChange({ year: value, month: selectedMonth });
    },
    [onChange, selectedMonth],
  );

  const handleMonthChange = useCallback(
    (e, { value }) => {
      setSelectedMonth(value);
      onChange({ year: selectedYear, month: value });
    },
    [onChange, selectedYear],
  );

  return (
    <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
      <Dropdown
        placeholder="Año"
        selection
        options={years}
        value={selectedYear}
        onChange={handleYearChange}
        className="year-filter-dropdown"
      />
      {/* <Dropdown
        placeholder="Mes"
        selection
        options={months}
        value={selectedMonth}
        onChange={handleMonthChange}
      /> */}
    </div>
  );
});

function FuelsComparisonChart({ resultsByYear, t }) {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Últimos 3 años
  const allYears = Object.keys(resultsByYear)
    .map(Number)
    .sort((a, b) => a - b);
  const years = allYears.slice(-3).map(String);

  const fuels = [
    { key: "natural_gas_cost", label: "Gas Natural" },
    { key: "glp_cost", label: "GLP" },
    { key: "diesel_cost", label: "Diesel" },
    { key: "cost_biodiesel", label: "Biodiesel" },
    { key: "gasoline_cost", label: "Gasolina" },
    { key: "ethanol_cost", label: "Etanol" },
    { key: "cost_electricity_vehicles", label: "Electricidad Vehículos" },
  ];

  const [selectedFuel, setSelectedFuel] = useState(fuels[0].key);

  // --- Datos para el gráfico mensual (por fuel) ---
  const monthlyData = useMemo(() => {
    const arr = [];
    years.forEach((year) => {
      months.forEach((month) => {
        const value =
          resultsByYear?.[year]?.[month]?.[selectedFuel]?.total || 0;
        arr.push({
          month: t(month),
          year,
          value,
        });
      });
    });
    return arr;
  }, [resultsByYear, years, selectedFuel]);

  // --- Datos para totales anuales ---
  // Datos totales por mes y año
  const data = useMemo(() => {
    const arr = [];
    years.forEach((year) => {
      months.forEach((month) => {
        const monthData = resultsByYear?.[year]?.[month] || {};

        const total = fuels.reduce(
          (acc, f) => acc + (monthData?.[f.key]?.total || 0),
          0,
        );
        arr.push({ month: t(month), year: String(year), value: total });
      });
    });
    return arr;
  }, [resultsByYear, years]);

  // Config gráfico mensual
  const monthlyConfig = {
    data: monthlyData,
    xField: "month",
    yField: "value",
    seriesField: "year",
    isGroup: true,
    colorField: "year",
    tooltip: {
      shared: true,
      title: (d) => d.value,
    },

    legend: { position: "bottom" },
  };
  // Config gráfico total anual
  const yearlyConfig = {
    data: data,
    xField: "month",
    yField: "value",
    seriesField: "year",
    isGroup: true,
    colorField: "year",
    tooltip: {
      shared: true,
      // formatter: (d) => ({
      //   name: `${t(selectedFuel)} (${d.year})`,
      //   value: d.value,
      // }),
    },
    legend: { position: "bottom" },
  };

  // Crear panes para Semantic UI Tab
  const panes = fuels.map((fuel) => ({
    menuItem: fuel.label,
    render: () => (
      <Tab.Pane>
        <div style={{ height: 400 }}>
          <Column {...monthlyConfig} />
        </div>
      </Tab.Pane>
    ),
  }));

  // Pestaña final de totales
  panes.push({
    menuItem: "Totales Anuales",
    render: () => (
      <Tab.Pane>
        <div style={{ height: 400 }}>
          <Column {...yearlyConfig} />
        </div>
      </Tab.Pane>
    ),
  });

  return (
    <div style={{ marginTop: 20, marginBottom: 40 }}>
      <h3 className="text-lg font-semibold mb-4 text-center">
        🔋 Comparativo de costos de combustibles
      </h3>
      <Tab
        panes={panes}
        menu={{ attached: false, tabular: false }}
        onTabChange={(e, data) => {
          const key = fuels[data.activeIndex]?.key;
          if (key) setSelectedFuel(key);
        }}
      />
    </div>
  );
}

function FuelsMonthlyChart({ resultsByYear, t }) {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const years = Object.keys(resultsByYear);

  // ✅ useMemo garantiza nueva referencia cuando cambia resultsByYear
  const { consumptionData, averageData } = useMemo(() => {
    const cData = [];
    const aData = [];

    years.forEach((year) => {
      const totals = months.map(
        (m) => resultsByYear?.[year]?.[m]?.total_energy_month?.total || 0,
      );
      const avg = totals.reduce((a, b) => a + b, 0) / totals.length;

      months.forEach((month, i) => {
        const total = totals[i];
        cData.push({
          year,
          month: t(month),
          value: total,
          type: "Consumo",
        });
        aData.push({
          year,
          month: t(month),
          value: avg,
          type: "Promedio",
        });
      });
    });

    return { consumptionData: cData, averageData: aData };
  }, [resultsByYear]); // 👈 se recalcula solo cuando cambian los datos

  // 🔹 Config del gráfico
  const config = {
    xField: "month",
    tooltip: {
      items: [
        (item) => {
          if (item.name) {
            return {
              name: item.name,
              value: item.count,
            };
          }
          return {
            name: item.type,
            value: item.value,
          };
        },
      ],
    },
    children: [
      {
        data: consumptionData,
        type: "line",
        yField: "value",
        colorField: "year",
        seriesField: "year", // 🔹 esto separa las barras por  año
        group: true,
        style: { maxWidth: 80 },
        interaction: { elementHighlight: { background: true } },
      },
      {
        data: averageData,
        type: "line",
        yField: "value",
        colorField: "year",
        style: { lineWidth: 2, lineDash: [4, 4] },
        axis: { y: { position: "right" } },
        scale: { series: { independent: true } },
        interaction: {
          tooltip: {
            crosshairs: false,
            marker: false,
          },
        },
      },
    ],
  };

  return (
    <div style={{ height: 450, marginTop: 20, marginBottom: 20 }}>
      <h3 className="text-lg font-semibold mb-2 text-center">
        Combustibles vs. Cantidad de vehículos
      </h3>
      <DualAxes {...config} />
    </div>
  );
}
